import { render, staticRenderFns } from "./buyChannelSelect.vue?vue&type=template&id=ba543a08&scoped=true"
import script from "./buyChannelSelect.vue?vue&type=script&lang=js"
export * from "./buyChannelSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba543a08",
  null
  
)

export default component.exports